/**
 * @description Directory for ID Attributes on MultiBarChart.
 * Naming Convention: "data-test-id-[VIEW/COMPONENT]-[ELEMENT]-[NAME]".
 * Example: id = "data-test-id-mainlayout-btn-cancel".
 */
const idDirectory = {
    divRoot: `multiBarChart-div-root`,
    divChart: `multiBarChart-div-chart`,
    divNoDataChart: `multiBarChart-div-noDataChart`,
    divLoading: `multiBarChart-div-loading`,
}

export default idDirectory
